export default (store) => {
  const { ability } = store.getters;

  ability.update(store.state.rules);

  return store.subscribe((mutation) => {
    switch (mutation.type) {
      case 'CREATE_SESSION':
        ability.update(mutation.payload.rules);
        break;
      case 'DESTROY_SESSION':
        ability.update([{ actions: 'read', subject: 'all' }]);
        break;
      default:
        break;
    }
  });
};
